import { clsx } from "clsx";
import type { EligibleSubsidy } from "@/features/subventions/types/subvention.types";
import { universeCounts } from "@/features/subventions/utils/subventionStatus";
import { NO_UNIVERSE } from "@/features/subventions/utils/universeActions";

type UniverseFilterProps = {
  subsidies: EligibleSubsidy[]
  selected: Set<string>
  onToggle: (universe: string) => void
};

export const UniverseFilter = ({ subsidies, selected, onToggle }: UniverseFilterProps) => {
  const counts = universeCounts(subsidies);
  const universes = Object.keys(counts).sort((a, b) => counts[b] - counts[a]);

  if (universes.length < 2) return null;

  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Filtrer par univers">
      {universes.map((universe) => {
        const active = selected.has(universe);
        return (
          <button
            key={universe}
            type="button"
            onClick={() => onToggle(universe)}
            aria-pressed={active}
            className={clsx(
              "inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-[12.5px] font-semibold transition-colors",
              active
                ? "border-primary bg-lightprimary text-primary-emphasis"
                : "border-gray-200 bg-white text-gray-600 hover:border-gray-300 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300",
            )}
          >
            <span
              aria-hidden="true"
              className={clsx(
                "h-2 w-2 rounded-full",
                universe === NO_UNIVERSE ? "bg-gray-400" : "bg-primary",
              )}
            />
            {universe}
            <span className="text-[11px] opacity-70">{counts[universe]}</span>
          </button>
        );
      })}
    </div>
  );
};

UniverseFilter.displayName = "UniverseFilter";
